import { Tag } from '@bitcine/cinesend-theme/dist'
import { Refresh } from '../icons'

const CycleIsValidatingTag = ({ is_validating = false }) => {
  return (
    <span className='font-medium inline-flex'>
      {is_validating && <Tag label='Validating' type='neutral' outline={true} icon={Refresh} iconPosition='right' />}
    </span>
  )
}

export default CycleIsValidatingTag
